import { EntityRatingCommentCount, Rating } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { EntityBarContainer } from './entity-bar-container.component';
import RatingEmptyState from './entity-rating-empty-state.component';

import { Star } from '@/components/ui/star.component';
import { formatRatingAverageLabel } from '@/utils/formatters/fomat-rating-average-label';

export interface RatingCardProps {
  rating: Rating;
  countComments?: EntityRatingCommentCount | null;
}

export function RatingCard({ rating, countComments }: RatingCardProps) {
  const average = rating.fiveStars.average!.toFixed(1).replace('.', ',');

  return (
    <section data-testid={DataTestIdEnum.ENTITY_RATING_CARD}>
      <div className="flex items-center gap-6 px-3">
        {(rating?.fiveStars?.count || 0) > 0
          ? (
              <>
                <div className="flex items-center flex-col gap-1.5">
                  <h3
                    className="text-gray-800 font-bold text-5xl"
                    data-testid={DataTestIdEnum.ENTITY_COUNT_AVERAGE}
                  >
                    {average}
                  </h3>
                  <Star rating={rating.fiveStars.average || 0} />
                  <span className="text-gray-800 font-semibold">{formatRatingAverageLabel(rating.fiveStars.average || 0)}</span>
                </div>
                <EntityBarContainer rating={rating} />
              </>
            )
          : (
              <RatingEmptyState />
            )}
      </div>

      {countComments && Number(countComments?.total) >= 1 && (
        <div className="mt-6">
          <span className="text-gray-600">
            {countComments.total > 1 ? `${countComments.total} comentários` : `${countComments.total} comentário`}
            {' '}
          </span>
        </div>
      )}
    </section>
  );
}
